import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [!_vm.dashboardIsFullscreen ? _c('dashboard-renderer', {
    attrs: {
      "active-dashboard": _vm.activeDashboard,
      "actual-date-range": _vm.actualDateRange,
      "status": _vm.status,
      "edit-mode": _vm.editMode,
      "show-edit-mode-button": _vm.hasEditPermissions,
      "custom-parameters": _vm.customParameters,
      "error": _vm.error,
      "dashboard-layers": _vm.dashboardLayers || [],
      "show-full-screen-button": "",
      "widget-min-size": _vm.dashboardIsFullscreen ? _vm.widgetMinSizeFullscreen : _vm.widgetMinSize
    },
    on: {
      "update:date-range": function ($event) {
        _vm.actualDateRange = $event;
      },
      "click:breadcrumb-layers": _vm.goToDashboardLayer,
      "update:edit-mode": function ($event) {
        _vm.editMode = $event;
      },
      "save-default-date-range": _vm.saveDefaultDateRange,
      "change:widget-order": _vm.persistsNewWidgetOrder,
      "activate-sub-dashboard": _vm.activateSubDashboard,
      "click:fullscreen": function ($event) {
        _vm.dashboardIsFullscreen = true;
      }
    }
  }) : _vm._e(), _c(VDialog, {
    attrs: {
      "fullscreen": "",
      "hide-overlay": ""
    },
    model: {
      value: _vm.dashboardIsFullscreen,
      callback: function ($$v) {
        _vm.dashboardIsFullscreen = $$v;
      },
      expression: "dashboardIsFullscreen"
    }
  }, [_c(VCard, {
    style: {
      height: '100%',
      minHeight: '100vh',
      backgroundColor: _vm.UiTheme ? '#2d2d2d' : '#E5E5E5'
    }
  }, [_c('dashboard-renderer', {
    attrs: {
      "active-dashboard": _vm.activeDashboard,
      "actual-date-range": _vm.actualDateRange,
      "status": _vm.status,
      "edit-mode": _vm.editMode,
      "show-edit-mode-button": _vm.hasEditPermissions,
      "custom-parameters": _vm.customParameters,
      "error": _vm.error,
      "dashboard-layers": _vm.dashboardLayers || [],
      "show-close-button": "",
      "widget-min-size": _vm.actualWidgetMinSize
    },
    on: {
      "update:date-range": function ($event) {
        _vm.actualDateRange = $event;
      },
      "click:breadcrumb-layers": _vm.goToDashboardLayer,
      "update:edit-mode": function ($event) {
        _vm.editMode = $event;
      },
      "save-default-date-range": _vm.saveDefaultDateRange,
      "change:widget-order": _vm.persistsNewWidgetOrder,
      "activate-sub-dashboard": _vm.activateSubDashboard,
      "close": function ($event) {
        _vm.dashboardIsFullscreen = false;
      }
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };